import React from 'react'
import { AboutsData } from './Data'
import { useNavigate } from 'react-router-dom';


const About = () => {
    
    const history=useNavigate();
    const pageMover=(page)=>{
      window.scrollTo(0,0)
      history(page)
    }

    return (
        <>
            <div className="about">
                <div className="about__content">
                    <h1>About us</h1>
                    <p>JNTUA College of Engineering Kalikiri is a
constituent college of JNTU Anantapur, catering to
the needs and dreams of rural students of
Rayalaseema in particular and Andhra Pradesh
in general. JNTUA College of Engineering
Kalikiri is just 45kms away from Madanapalle en
route to Tirupati and just 75kms away from
Tirupati. The college started functioning from the
academic year 2013-2014 as the 3
rd constituent
Engineering college of JNTUA. The campus is spread
on sprawling 107.2 acres with various departments
& labs housed in built up area of 11,43,713sq.ft.</p>
<br />
<p>ECLATECS 2K22 is a 2 day National level student’s
Technocultural fest being organized by the
department of ECE. The objective of this fest is to
create a common platform for participants from
various colleges to share, improve and focus on
present technological advancements. It also
improves technical knowledge in various fields of
Electronics and Communications.</p>

                    <div className="about__icons">
                       {AboutsData.map((item)=>{
                           return(
                            <div className="about1">
                                <h3>{item.name}</h3>
                            <img onClick={()=>pageMover(item.page)} src={item.img} alt="" />
                        </div>
                           )
                       })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default About
